import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { startSession } from "../utils/session";
import ActivityPage from "./activity-page/ActivityPage";
import BookingPage from "./booking-page/BookingPage";
import ChangePasswordPage from "./change-password-page/ChangePasswordPage";
import CompanyPage from "./company-page/CompanyPage";
import ForgotPasswordPage from "./forgot-password-page/ForgotPasswordPage";
import InvitationPage from "./invitation-page/InvitationPage";
import Layout from "./layout/Layout";
import NoMatch from "./NoMatch";
import ProfilePage from "./profile-page/ProfilePage";
import ResetPasswordPage from "./reset-password-page/ResetPasswordPage";
import { Toaster } from "./toaster/Toaster";
import UserPage from "./user-page/UserPage";
import RegisterPage from "./register-page/RegisterPage";
import InvoiceImportPage from "./invoice-import-page/InvoiceImportPage";

const App = () => {
  useEffect(() => {
    startSession();
  }, []);

  return (
    <>
      <Toaster />

      <Routes>
        <Route path="/" element={<Layout />}>
          <Route path="forgot-password/*" element={<ForgotPasswordPage />} />
          <Route path="register/*" element={<RegisterPage />} />
          <Route path="reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="invitation/:token" element={<InvitationPage />} />
          <Route path="change-password/*" element={<ChangePasswordPage />} />
          <Route path="profile/*" element={<ProfilePage />} />
          <Route path="activity/*" element={<ActivityPage />} />
          <Route path="bookings/*" element={<BookingPage />} />
          <Route path="companies/*" element={<CompanyPage />} />
          <Route path="users/*" element={<UserPage />} />
          <Route path="invoice-import/*" element={<InvoiceImportPage />} />
          <Route path="*" element={<NoMatch />} />
        </Route>
      </Routes>
    </>
  );
};

export default App;
